module.exports = __webpack_public_path__ + "img/img_manual2_3.94e6a842.jpg";